import { Popup, ErrorPopup, httpAxios } from "../../core/classes/BaseStore";
import $i18n from "@/i18n";
import axios from "axios";
const uuidv4 = require("uuid/v4");
import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { Notification } from "@/modules/notifications/viewmodels/Notification";

// state
export const state = {
  channels: null,
  notifications: [],
  celebrations: [],
};

export const getters = Object.assign(
  {
    notifications: (state) => {
      return state.notifications;
    },
    celebrations: (state) => {
      return state.celebrations;
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/notifications",
    Notification,
    {
      // Hooks
    },
    {
      /**
       * Mark a notification as read
       * this.$store.getters['notification/api'].Custom.Read()
       */
      Read: async (notificationId) => {
        let ApiResult = null;

        try {
          ApiResult = await httpAxios.put(
            process.env.VUE_APP_BASE_URL +
              "/api/notifications/" +
              notificationId,
            { read: true }
          );
        } catch (err) {
          return;
          err.response;
        }
        return ApiResult;
      },
      /**
       * Unmark a notification as read
       * this.$store.getters['notification/api'].Custom.Unread()
       */
      Unread: async (notificationId) => {
        const api = new ApiAsyncHelper();
        let ApiResult = null;

        try {
          ApiResult = await api.$http.put(
            process.env.VUE_APP_BASE_URL +
              "/api/notifications/" +
              notificationId,
            { read: false }
          );
        } catch (err) {
          return;
          err.response;
        }
        return ApiResult;
      },

      /**
       * Get gif from giphy
       * this.$store.getters['notification/api'].Custom.Gif()
       */
      Gif: async () => {
        const api = new ApiAsyncHelper();
        let ApiResult = null;

        try {
          ApiResult = await axios.get(
            "https://api.giphy.com/v1/gifs/random?api_key=" +
              process.env.VUE_APP_GIPHY_KEY +
              "&tag=gratulation&rating=G"
          );
        } catch (err) {
          return;
          err.response;
        }

        return ApiResult.data.data;
      },
    }
  )
);

// mutations
export const mutations = {
  removeCelebration: (state, Id) => {
    let index = state.celebrations.findIndex((e) => e.id === Id);
    state.celebrations.splice(index, 1);
  },
};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/notifications",
  [],
  {
    async joinChannel({ commit, dispatch }, userId) {
      if (state.channels === `user-${userId}`) return;
      await window.Echo.leave(`user-${userId}`);

      console.log(`Joining user-${userId}`);

      let result = window.Echo.join(`user-${userId}`)
        .here((users) => {
          // get online users
        })
        .joining((user) => {})
        .leaving((user) => {
          // User is leaving
        })
        .listen("Activities.AllCategoriesFinished", (e) => {
          state.celebrations.push({
            id: uuidv4(),
            type: "allCategories",
            title: "",
          });
        })
        .listen("Targets.TargetRetry", (e) => {
          dispatch("target/updateTarget", e.target, { root: true });
          Popup({
            type: "info",
            title: $i18n.t("targets.target_was_restarted"),
            text: $i18n.t("targets.target_was_restarted_message", {
              activity: e.activity.title,
            }),
          });
        })
        .listen("Targets.TargetFinished", (e) => {
          dispatch("target/finishTarget", e.target.id, { root: true });
          state.celebrations.push({
            id: uuidv4(),
            type: "target",
            title: e.activity.title,
            text: e.target.group
              ? $i18n.t("actions.group_finished_activity", {
                  activity: e.activity.title,
                  count: e.target.target,
                })
              : $i18n.t("actions.you_finished_activity", {
                  activity: e.activity.title,
                  count: e.target.target,
                }),
          });
        })
        .listen("Targets.TargetFailed", (e) => {
          dispatch("target/updateTarget", e.target, { root: true });
          Popup({
            type: "info",
            title: $i18n.t("targets.target_failed"),
            text: $i18n.t("targets.target_failed_message", {
              activity: e.activity.title,
            }),
          });
        })
        .listen("Targets.TargetStarted", (e) => {
          dispatch("target/updateTarget", e.target, { root: true });
          Popup({
            type: "info",
            title: $i18n.t("targets.target_started"),
            text: $i18n.t("targets.target_started_message", {
              activity: e.activity.title,
            }),
          });
        })
        .listen("Targets.TargetInvite", (e) => {
          dispatch("targetinvitation/addTargetInvitation", e.targetInvitation, {
            root: true,
          });
          Popup({
            type: "info",
            text: $i18n.t("targets.invitation.you_have_been_invited"),
          });
        });
      if (result) {
        state.channels = `user-${userId}`;
      }
      return;
    },
    removeCelebration({ commit, dispatch }, Id) {
      commit("removeCelebration", Id);
    },
  }
);
